module.exports = __webpack_public_path__ + "img/valance-whale.724c0f40.svg";